import { Avatar, AvatarFallback, AvatarImage } from '@e2n/ui';
import { Beruf } from '@/domain/mitarbeiter/features/rotationsplan/entities/Beruf';
import { Mitarbeiter } from '@/domain/mitarbeiter/features/rotationsplan/entities/Mitarbeiter';
import { ArbeitsbereichStation } from '@/domain/mitarbeiter/features/rotationsplan/entities/Station';
import dayjs from '@/domain/mitarbeiter/shared/utils/dayjs';
import { faCalendarRange } from '@fortawesome/pro-regular-svg-icons';
import { faCircle } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Abwesenheit } from '@/domain/mitarbeiter/features/rotationsplan/entities/Abwesenheit';

export function StationMitarbeiterCard({
  station,
  mitarbeiter,
  lehrjahr,
  beruf,
  currentStartOfWeek,
  currentEndOfWeek,
  abwesenheiten,
}: {
  station: ArbeitsbereichStation;
  mitarbeiter: Mitarbeiter;
  lehrjahr: string;
  beruf: Beruf;
  currentStartOfWeek: string;
  currentEndOfWeek: string;
  abwesenheiten: Abwesenheit[];
}) {
  return (
    <div className="bg-white p-4 rounded-md flex flex-col gap-4">
      <div className="flex gap-3 items-center">
        <Avatar>
          <AvatarImage
            alt={mitarbeiter.vorname + ' ' + mitarbeiter.nachname}
            src={mitarbeiter.imgUrl}
          />
          <AvatarFallback>
            {mitarbeiter.vorname[0].toUpperCase() +
              mitarbeiter.nachname[0].toUpperCase()}
          </AvatarFallback>
        </Avatar>
        <div className="flex flex-col gap-1">
          <div className="text-sm font-semibold">
            {mitarbeiter.vorname + ' ' + mitarbeiter.nachname}
          </div>
          <div className="text-xs text-neutrals-700">
            {lehrjahr + ' ⋅ ' + beruf.abkuerzung}
          </div>
        </div>
      </div>
      <div className="flex flex-col gap-2">
        <div className="flex gap-2 items-center text-xs">
          <FontAwesomeIcon
            icon={faCircle}
            color={station.arbeitsbereich.getBorderColor()}
          />
          <div className="font-semibold">{station.arbeitsbereich.name}</div>
        </div>
        <div className="text-xs text-neutrals-700 flex gap-1 items-center">
          <FontAwesomeIcon icon={faCalendarRange} />
          <div>
            {dayjs(station.von).format('DD.MM.YYYY') +
              ' – ' +
              dayjs(station.bis).format('DD.MM.YYYY')}
          </div>
        </div>
      </div>
      {abwesenheiten
        .filter(
          (abwesenheit) =>
            dayjs(abwesenheit.von).isSameOrBefore(currentEndOfWeek) &&
            dayjs(abwesenheit.bis).isSameOrAfter(currentStartOfWeek),
        )
        .map((abwesenheit) => (
          <div key={abwesenheit.id} className="flex flex-col gap-2 text-xs">
            <div className="flex gap-1 items-center font-semibold">
              <FontAwesomeIcon icon={abwesenheit.abwesenheitsgrundIcon} />
              <div>{abwesenheit.grund}</div>
            </div>
            <div className="text-neutrals-700">{abwesenheit.zeitraumLabel}</div>
          </div>
        ))}
    </div>
  );
}
